import { TripsTabContainer } from './TripsTabContainer';

export default TripsTabContainer;
